var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('accountsWithdrawals.accountWithdrawals')))]),(
          _vm.$parent.item.stat == 1 &&
          _vm.$site.accountsWithdrawals_allow &&
          (_vm.$user.admin ||
            _vm.$user.role.accounts_withdrawals_add)
        )?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/accountsWithdrawals/create?safe_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.safes.addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('accountsWithdrawals.SearchForAnOperation'),"emptyTableText":_vm.$t('accountsWithdrawals.thereAreNoWithdrawalsOperations'),"filter":{safe_id: _vm.$route.params.id},"withoutCard":true,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        {
          column: 'code',
          title: _vm.$t('accountsDeposits.Process'),
          type: 'mainLink',
          sort: true,
        },
        {
          column: 'account_id',
          title: _vm.$t('accountsDeposits.accountName'),
          type: 'link',
          to: 'account',
          sort: true,
          link: true,
        },
        {
          column: 'safe_id',
          title: _vm.$t('accountsDeposits.Treasury'),
          type: 'link',
          to: 'safe',
          sort: true,
          link: true,
        },
        {
          column: 'date',
          title: _vm.$t('accountsDeposits.date'),
          type: 'text',
          sort: true,
        },
        {
          column: 'description',
          title: _vm.$t('accountsDeposits.AndThatIsAbout'),
          type: 'text',
          sort: true,
        },
        {
          column: 'cost',
          title: _vm.$t('accountsDeposits.cost'),
          type: 'text',
          sort: true,
        },
        {
          column: 'options',
          title: _vm.$t('partnersDeposits.actions'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
              _vm.$user.admin || _vm.$user.role.accounts_deposits_edit,
            },
            { name: 'printSalesPayment', role: true },
            { name: 'download', role: true },
            {
              name: 'delete',
              role:
              _vm.$user.admin ||
              _vm.$user.role.accounts_deposits_delete,
            } ],
        } ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem:
          _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading'),
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }